<template>
  <div>
    <PageAllow controller="SubAccountSettings" action="index" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="6">
            <v-card>
              <v-card-title
                >{{ $t("SubAccountSettingPort.yisheng") }}
                <v-chip
                  small
                  label
                  class="ml-2"
                  :color="easy_status | accountStatusColor"
                  :text-color="easy_status | accountStatusTextColor"
                >
                  {{ easy_status | accountStatusText }}
                </v-chip>
              </v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col>
                    {{ $t("SubAccountSettingPort.ys_hint") }}
                    <br />
                    {{ $t("SubAccountSettingPort.ys_hint2") }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-img
                      height="48px"
                      contain
                      src="	http://test.yywd.vip/img/payment/easypay268x87.jpg"
                    ></v-img>
                  </v-col>

                  <v-col>
                    <v-btn
                      class="float-end primary"
                      @click="
                        $router.replace(
                          '/settings/sub-account-settings/sub-account-setting-port/sub-account-easy-pay-setting'
                        )
                      "
                    >
                      {{ $t("SubAccountSettingPort.setParas") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" align-self="center">
            <v-card>
              <v-card-title
                >{{ $t("SubAccountSettingPort.huifu") }}
                <v-chip
                  small
                  label
                  class="ml-2"
                  :color="hf_status | accountStatusColor"
                  :text-color="hf_status | accountStatusTextColor"
                >
                  {{ hf_status | accountStatusText }}
                </v-chip></v-card-title
              >
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col>
                    {{ $t("SubAccountSettingPort.huifu_hint") }}
                    <br />
                    {{ $t("SubAccountSettingPort.huifu_hint2") }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-img
                      height="48px"
                      contain
                      src="	http://test.yywd.vip/img/payment/hfpay273x86.jpeg"
                    ></v-img>
                  </v-col>

                  <v-col>
                    <v-btn
                      class="float-end primary"
                      @click="
                        $router.replace(
                          '/settings/sub-account-settings/sub-account-setting-port/sub-account-hf-pay-setting'
                        )
                      "
                    >
                      {{ $t("SubAccountSettingPort.setParas") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" align-self="center">
            <v-card>
              <v-card-title
                >{{ $t("SubAccountSettingPort.agricultural_bank") }}
                <v-chip
                  small
                  label
                  class="ml-2"
                  :color="abc_status | accountStatusColor"
                  :text-color="abc_status | accountStatusTextColor"
                >
                  {{ abc_status | accountStatusText }}
                </v-chip></v-card-title
              >
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col>
                    {{ $t("SubAccountSettingPort.abc_hint") }}
                    <br />
                    {{ $t("SubAccountSettingPort.abc_hint2") }}
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col>
                    <v-img
                      height="48px"
                      contain
                      src="	http://test.yywd.vip/img/payment/hfpay273x86.jpeg"
                    ></v-img>
                  </v-col> -->

                  <v-col>
                    <v-btn
                      class="float-end primary"
                      @click="
                        $router.replace(
                          '/settings/sub-account-settings/sub-account-setting-port/sub-account-abc-setting'
                        )
                      "
                    >
                      {{ $t("SubAccountSettingPort.setParas") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" align-self="center">
            <v-card>
              <v-card-title
                >{{ $t("SubAccountSettingPort.ws_bank") }}
                <v-chip
                  small
                  label
                  class="ml-2"
                  :color="ws_status | accountStatusColor"
                  :text-color="ws_status | accountStatusTextColor"
                >
                  {{ ws_status | accountStatusText }}
                </v-chip></v-card-title
              >
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col>
                    {{ $t("SubAccountSettingPort.ws_hint") }}
                    <br />
                    {{ $t("SubAccountSettingPort.ws_hint2") }}
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col>
                    <v-img
                      height="48px"
                      contain
                      src="	http://test.yywd.vip/img/payment/hfpay273x86.jpeg"
                    ></v-img>
                  </v-col> -->

                  <v-col>
                    <v-btn
                      class="float-end primary"
                      @click="
                        $router.replace(
                          '/settings/sub-account-settings/sub-account-setting-port/sub-account-ws-setting'
                        )
                      "
                    >
                      {{ $t("SubAccountSettingPort.setParas") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" align-self="center">
            <v-card>
              <v-card-title>
                {{ $t("SubAccountSettingPort.ccb") }}
                <v-chip
                  small
                  label
                  class="ml-2"
                  :color="ccb_status | accountStatusColor"
                  :text-color="ccb_status | accountStatusTextColor"
                >
                  {{ ccb_status | accountStatusText }}
                </v-chip>
              </v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col>
                    {{ $t("SubAccountSettingPort.ccb_hint") }}
                    <br />
                    {{ $t("SubAccountSettingPort.ccb_hint2") }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-img
                      height="48px"
                      contain
                      :src="require('@/assets/payment/ccb.jpg')"
                    ></v-img>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="float-end primary"
                      @click="
                        $router.replace(
                          '/settings/sub-account-settings/sub-account-setting-port/sub-account-ccb-setting'
                        )
                      "
                    >
                      {{ $t("SubAccountSettingPort.setParas") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" align-self="center">
            <v-card>
              <v-card-title>
                {{ $t("SubAccountSettingPort.lkl") }}
                <v-chip
                  small
                  label
                  class="ml-2"
                  :color="lkl_status | accountStatusColor"
                  :text-color="lkl_status | accountStatusTextColor"
                >
                  {{ lkl_status | accountStatusText }}
                </v-chip>
              </v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <v-row>
                  <v-col>
                    {{ $t("SubAccountSettingPort.lkl_hint") }}
                    <br />
                    {{ $t("SubAccountSettingPort.lkl_hint2") }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-img
                      width="300px"
                      height="48px"
                      contain
                      :src="require('@/assets/payment/lkl.jpg')"
                    ></v-img>
                  </v-col>
                  <v-col>
                    <v-btn
                      class="float-end primary"
                      @click="$router.replace('/settings/sub-account-settings/sub-account-setting-port/sub-account-lkl-setting')"
                    >
                      {{ $t("SubAccountSettingPort.setParas") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Setting from "@/api/settings";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
// import SubAccountSettings from "@/api/sub_account_settings";

export default {
  data: () => ({
    paging: {},
    currentItem: null,
    easy_status: null,
    hf_status: null,
    abc_status: null,
    ws_status: null,
    ccb_status: null,
    lkl_status: null,
  }),

  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.subAccountSettings"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-type",
      },
      {
        text: i18n.t("SettingNav.subAccountSettingPort"),
        disabled: true,
        href: "/settings/sub-account-settings/sub-account-setting-port",
      },
    ],

    ...mapState(["loading", "stickTableCols"]),
  },

  mounted() {
    // 获取易生分账参数
    Setting.settings("keys[]=easypay_sub_account_enable").then(
      function (response) {
        if (response.data.status.isOK()) {
          this.easy_status = response.data.settings.easypay_sub_account_enable;
        }
      }.bind(this)
    );
    // 获取汇付分账参数
    Setting.settings(
      "keys[]=hfpay_sub_account_cust_id&keys[]=hfpay_sub_account_acct_id&keys[]=hfpay_cash_fee_enable&keys[]=hfpay_sub_account_enable"
    ).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.hf_status = response.data.settings.hfpay_sub_account_enable;
        }
      }.bind(this)
    );
    // 获取易生分账参数
    Setting.settings("keys[]=abc_sub_account_enable").then(
      function (response) {
        if (response.data.status.isOK()) {
          this.abc_status = response.data.settings.abc_sub_account_enable;
        }
      }.bind(this)
    );
    //  获取网商分账参数
    Setting.settings("keys[]=ws_sub_account_enable").then(
      function (response) {
        if (response.data.status.isOK()) {
          this.ws_status = response.data.settings.ws_sub_account_enable;
        }
      }.bind(this)
    );
    //  获取建行分账参数
    Setting.settings("keys[]=ccb_scan_sub_account_enable").then(
      function (response) {
        if (response.data.status.isOK()) {
          this.ccb_status = response.data.settings.ccb_scan_sub_account_enable;
        }
      }.bind(this)
    );
    //  获取建行分账参数
    Setting.settings("keys[]=lkl_sub_account_enable").then(
      function (response) {
        if (response.data.status.isOK()) {
          this.lkl_status = response.data.settings.lkl_sub_account_enable;
        }
      }.bind(this)
    );
  },

  methods: {},

  watch: {},
};
</script>

<style>
</style>